// store/features/api/doctorPayoutApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

const normalizeDoctorFinanceParams = (params = {}) => {
  const { startDate, endDate, ...rest } = params;
  return {
    ...rest,
    ...(startDate ? { start_date: startDate } : {}),
    ...(endDate ? { end_date: endDate } : {}),
  };
};

export const doctorPayoutApi = createApi({
  reducerPath: "doctorPayoutApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}doctor-payout/`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token || localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["DoctorPayout"],
  endpoints: (builder) => ({
    getDoctorPayouts: builder.query({
      query: (params) => ({
        url: "",
        params: normalizeDoctorFinanceParams(params),
      }),
      providesTags: ["DoctorPayout"],
    }),
    getDoctorPayout: builder.query({
      query: (id) => `${id}`,
      providesTags: ["DoctorPayout"],
    }),
    getPayoutStats: builder.query({
      query: (params) => ({
        url: "stats",
        params: normalizeDoctorFinanceParams(params),
      }),
      providesTags: ["DoctorPayout"],
    }),
    getPendingPayoutsSummary: builder.query({
      query: (params) => ({
        url: "pending-summary",
        params: normalizeDoctorFinanceParams(params),
      }),
      providesTags: ["DoctorPayout"],
    }),
    addDoctorPayout: builder.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["DoctorPayout", "doctor_earning"],
    }),
    updateDoctorPayout: builder.mutation({
      query: ({ id, data }) => ({
        url: `${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["DoctorPayout"],
    }),
    deleteDoctorPayout: builder.mutation({
      query: (id) => ({
        url: `${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["DoctorPayout", "doctor_earning"],
    }),
    processPayout: builder.mutation({
      query: ({ id, data }) => ({
        url: `${id}/process`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["DoctorPayout"],
    }),
  }),
});

export const {
  useGetDoctorPayoutsQuery,
  useGetDoctorPayoutQuery,
  useGetPayoutStatsQuery,
  useGetPendingPayoutsSummaryQuery,
  useAddDoctorPayoutMutation,
  useUpdateDoctorPayoutMutation,
  useDeleteDoctorPayoutMutation,
  useProcessPayoutMutation,
} = doctorPayoutApi;
